/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Top_Users_DescriptionInputs */



/**
* | output |
* | --- |
* | "Usage distribution by highest consumers" |
*
* @param {Dashboard_Top_Users_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_top_users_description = /** @type {((inputs?: Dashboard_Top_Users_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Top_Users_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsverteilung nach größten Konsumenten")
	return /** @type {LocalizedString} */ ("Usage distribution by highest consumers")
});